interface Props {
  size?: number;
}

export default function Logo({ size = 36 }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>Grundfos Logo</title>
      <g id="Logo" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="01-Element/Logo/Logo-symbol" fill="#FFFFFF">
          <path
            d="M14.4242356,18.632386 C14.4242356,18.632386 14.9008679,18.9206679 15.9178736,19.9306092 C16.9491498,20.954869 17.257391,21.4331115 17.257391,21.4331115 L12.2104168,26.5 L6.58977147,26.5 C9.17996365,23.9010572 11.7323308,21.3372105 13.1889909,19.8736516 L13.4344591,19.6270149 C13.7460104,19.3139732 13.9934545,19.0653159 14.1630108,18.8949191 L14.2753588,18.7820122 C14.2915777,18.7657123 14.3065257,18.7506894 14.320176,18.7369706 L14.4242356,18.632386 L14.4242356,18.632386 Z M22.9149491,18.8691208 C23.7730774,19.903881 24.6892388,21.1142832 25.531194,22.4669171 C26.3151161,23.7260026 27.038151,25.0719546 27.5185887,26.5 L24.3581649,26.5 C24.3581649,26.5 23.9899879,25.4547395 22.877846,23.7088203 C21.9142307,22.192572 21.0235521,21.2514397 20.8236653,21.0474019 L20.781996,21.0054615 L20.781996,21.0054615 L22.9149491,18.8691208 Z M27.5182082,5.5 L27.5182082,11.1272245 L19.3964328,19.2831204 C19.3964328,19.2831204 18.5173745,18.3610001 18.0645263,17.9161678 C13.2915443,13.2062907 8.86390663,10.9229453 7.76222971,12.0121163 C6.28571625,13.4668899 10.8417877,18.7714677 11.0006652,19.0082025 L9.61833652,20.3885192 C6.64342827,16.7525399 5.81574353,15.1688986 5.05845957,13.2807476 C4.57516779,12.0760729 3.97961532,9.71922516 5.21067745,8.48304946 C6.30284076,7.38910556 8.44816154,7.76711759 10.6115582,8.73887578 C13.0927097,9.85286577 15.9515518,11.8861123 18.6391488,14.4100108 L27.5182082,5.5 Z"
            id="Combined-Shape"
          ></path>
        </g>
      </g>
    </svg>
  );
}
